import { createResponsiveConnect } from '@team-griffin/react-matchmedia-connect';
import React, { createContext, Fragment, useContext } from 'react';
import pureEnhance from '@ux/pure-enhance';
import { defaultProps } from '@team-griffin/rehook';

/* eslint-disable max-len */
// Used as min-width triggers
// Rationale for these numbers:
// https://sketch.cloud/s/4gYaZ/all/rationale/brand-ga-stats
// https://confluence.emea.godaddy.com:8443/pages/viewpage.action?spaceKey=PL&title=GoDaddy+EMEA+Unified+Design+System
// example @ https://www.mattstevens.co.uk/godaddy/grid/
var breakpoints;

(function (breakpoints) {
  breakpoints[breakpoints["xs"] = 0] = "xs";
  breakpoints[breakpoints["sm"] = 750] = "sm";
  breakpoints[breakpoints["md"] = 1020] = "md";
  breakpoints[breakpoints["lg"] = 1300] = "lg";
  breakpoints[breakpoints["xl"] = 1800] = "xl";
})(breakpoints || (breakpoints = {}));

var breakpointConnect = createResponsiveConnect(breakpoints);

var BreakpointContext = createContext(null);
var Provider = BreakpointContext.Provider,
    Consumer = BreakpointContext.Consumer;

var BreakpointRoot = function BreakpointRoot(_ref) {
  var children = _ref.children,
      isMinSm = _ref.isMinSm,
      isMinMd = _ref.isMinMd,
      isMinLg = _ref.isMinLg,
      isMinXl = _ref.isMinXl;
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      isMinSm: isMinSm,
      isMinMd: isMinMd,
      isMinLg: isMinLg,
      isMinXl: isMinXl
    }
  }, /*#__PURE__*/React.createElement(Fragment, null, children));
};

var enhance = pureEnhance('BreakpointRoot', {
  hocs: [breakpointConnect()]
});
var BreakpointRoot$1 = enhance(BreakpointRoot); // eslint-disable-next-line no-underscore-dangle

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function withBreakpoints(DecoratedComponent) {
  var WithBreakpoints = function WithBreakpoints(props) {
    return /*#__PURE__*/React.createElement(Consumer, null, function (value) {
      return /*#__PURE__*/React.createElement(DecoratedComponent, _extends({}, props, value));
    });
  };

  return WithBreakpoints;
}

var useBreakpoints = function useBreakpoints() {
  return useContext(BreakpointContext);
};

var withBreakpoints$1 = function withBreakpoints(props) {
  return Object.assign({}, useBreakpoints(), props);
};

var BreakpointRoot$2 = function BreakpointRoot(_ref) {
  var children = _ref.children,
      isMinSm = _ref.isMinSm,
      isMinMd = _ref.isMinMd,
      isMinLg = _ref.isMinLg,
      isMinXl = _ref.isMinXl;
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      isMinSm: isMinSm,
      isMinMd: isMinMd,
      isMinLg: isMinLg,
      isMinXl: isMinXl
    }
  }, /*#__PURE__*/React.createElement(Fragment, null, children));
};

var enhance$1 = pureEnhance('StubBreakpointRoot', [defaultProps({
  isMinSm: false,
  isMinMd: false,
  isMinLg: false,
  isMinXl: false
})]);
var StubBreakpointRoot = enhance$1(BreakpointRoot$2); // eslint-disable-next-line no-underscore-dangle

export { BreakpointRoot$1 as BreakpointRoot, StubBreakpointRoot, breakpointConnect, breakpoints, useBreakpoints, withBreakpoints, withBreakpoints$1 as withBreakpointsHook };
